import { render, staticRenderFns } from "./MateEntering.vue?vue&type=template&id=3d24fd67&scoped=true"
import script from "./MateEntering.vue?vue&type=script&lang=js"
export * from "./MateEntering.vue?vue&type=script&lang=js"
import style0 from "./MateEntering.vue?vue&type=style&index=0&id=3d24fd67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24fd67",
  null
  
)

export default component.exports